/** Short on-device listening cue. No network, no speech content. */
export function playAmbientHeidiEarcon(): void {
  if (typeof window === 'undefined' || typeof window.AudioContext === 'undefined') {
    return;
  }
  let context: AudioContext | undefined;
  try {
    context = new window.AudioContext();
    const oscillator = context.createOscillator();
    const gain = context.createGain();
    oscillator.type = 'sine';
    oscillator.frequency.value = 880;
    gain.gain.value = 0.05;
    oscillator.connect(gain);
    gain.connect(context.destination);
    oscillator.start();
    gain.gain.exponentialRampToValueAtTime(0.0001, context.currentTime + 0.12);
    oscillator.stop(context.currentTime + 0.14);
    oscillator.onended = () => {
      void context?.close();
    };
  } catch {
    void context?.close();
  }
}
